module.exports = __webpack_public_path__ + "img/15.e315d7cf.svg";